export const messages = {
    deleteConfirm: "Do you really want to delete this ",
    failed: "Unable to proceed your request, please try later.",
    subscriptionSuccess: "Subscription package purchased successfully",
    subscriptionFailed: "Failed to purchase subscription package, please try again",
    cancelSubscription : "Are you sure want to cancel the subscription? Once its done, It cannot be roll back. You will be able to access the system till your subscription end date.",
    couponCodeValidation: "Please enter the coupon code."
}